/* eslint-disable no-unused-vars */
//-------------------------MASTER START-----------------------------------//

import Master from "../views/Master";
import AddPacketMapping from "../views/Master/PacketingGuide/AddPacketMapping";
import PincodeMaster from "../views/Master/PincodeMaster";
import RouteMaster from "../views/Master/Route";
import HubRouteMaster from "../views/Master/vehicleRoute";

import FirstAndLastMileTAT from "../views/Master/TAT/FirstAndLastMile";
import VehicleOnboard from "../views/Master/VehicleOnboard";
import MiddleMileTAT from "../views/Master/TAT/middleMile";
import MasterChild from "../views/Master/RateCard/masterChild";
import PacketingGuide from "../views/Master/PacketingGuide";
import PinCodeMapping from "../views/Master/PinCodeMapping";
import TatConfiguration from "../views/Master/TAT/TatConfiguration";
import TatCalulator from "../views/Master/TAT/TatCalculator";
import VehicleMaster from "../views/Master/Vehicle";
import SortingGuide from "../views/Master/SortingGuide";
import HubOnboarding from "../views/Master/HubOnboard";
import AllocateTemplate from "../views/Master/RateCard/CashbookingRateCard/allocateTemplate";

//-------------------------MASTER END-----------------------------------//

//-------------------------FIRST MILE START-----------------------------------//

import BookingTabs from "../views/viewBookingTable/viewBookingTabs";
import ScanedandManifestList from "../views/viewBookingTable/ScanedandManifestList";
import ChildPacketScan from "../views/viewBookingTable/ChildPacketScann";
import PrintManifest from "../views/viewBookingTable/PrintManifest";
import ViewManifest from "../views/viewBookingTable/viewBookingTabs/ViewManifest";
import Truck from "../views/viewBookingTable/Truck";
import NewTruck from "../views/viewBookingTable/Truck/newTruck";
import PrintBooking from "../views/PrintBooking";

import PacketingCP from "../views/FirstMile/Packeting";
import NewBookedSuccessfull from "../views/FirstMile/RetailBooking/BookingSuccess";

import CPEWayBill from "../views/EwayBill/CPEwayBill";
import LastMileEWayBill from "../views/EwayBill/LastMileEwayBill";
import printEwayBill from "../views/EwayBill/PrintEwayBill/index";

//-------------------------FIRST MILE END-----------------------------------//

//----------------------------Middle Mile START---------------------------------------//

import HubManifestEWayBill from "../views/EwayBill/HubManifestEwayBill";
import HubEWayBill from "../views/EwayBill/HubEwayBill";
import ExtendEWayBill from "../views/EwayBill/ExtendEwayBill";
import Audits from "../views/Audit";

import Settings from "../views/Settings";

//----------------------------Middle Mile END---------------------------------------//

//----------------------------LastMileOperations START-----------------------------------//

import DrsGeneration from "../views/LastMileOperations/DrsGeneration/index";
import InScanCP from "../views/LastMileOperations/InScanCP";
import CreateVirtualArea from "../views/LastMileOperations/VirtualArea";
import DrsDetails from "../views/LastMileOperations/DrsGeneration/DrsDetails";
import printDrs from "../views/LastMileOperations/DrsGeneration/printDrs";
import PrintGenerateManifest from "../views/PrintGenerateManifest";
import PendingDrs from "../views/LastMileOperations/PendingDrs";
import CashRTo from "../views/LastMileOperations/RTO/CashRto";
import CreditRTO from "../views/LastMileOperations/RTO/CreditRto";

//----------------------------LastMileOperations END-----------------------------------//

//----------------------------Stationary START---------------------------------------//

import AddCategory from "../views/HoStationary/AddCategory/inedx";
import AddProduct from "../views/HoStationary/AddProduct";
import ProductCP from "../views/CPStationary/Product";
import ProductDetails from "../views/CPStationary/Product/productDetails";
import HoStationary from "../views/HoStationary";
import ProductTabs from "../views/HoStationary/productTabs";
import OrderRequest from "../views/HoStationary/OrderRequest";
import OrderDetailsHo from "../views/HoStationary/OrderDetails";
import CartPage from "../views/CPStationary/Cart";
import OrderHistory from "../views/CPStationary/Order";
import OrderDetails from "../views/CPStationary/Order/orderDetails";
//----------------------------Stationary END---------------------------------------//

import StateMaster from "../views/StateMaster/index";
import PrsGenerationTab from "../views/PrsGeneration/PrsGenerationTab";

import VehicleList from "../views/Report/Vehicle";
import TripListByVehicle from "../views/Report/Vehicle/tripList";
import VehicleCkinCkout from "../views/Report/VehicleCkinCkout";
// CP Onboarding New

import CpOnboardingNew from "../views/CpOnboardingNew/index";
import KycView from "../views/CpOnboardingNew/KycView";
import CompanyBranch from "../views/CompanyBranch";

import CpLeadGen from "../views/LeadGenerationCP";
import ClientLeadList from "../views/LeadGenerationClient";
import CPLeadList from "../views/CPLeadList";
import ClientLeadGeneration from "../views/LeadGenerationClient/LeadGenClientSteps";
import ClientQuotationList from "../views/LeadGenerationClient/CreateQuoteList";
import CPQuotationList from "../views/LeadGenerationCP/CPQuotationList";

import NewQuotation from "../views/LeadGenerationClient/NewQuote";
import CPNewQuotation from "../views/LeadGenerationCP/AllocateRateCard";

import ScheduleMeetingModal from "../views/ClientLeadList/ScheduleMeetingModal";
import SendEmailModal from "../views/ClientLeadList/SendEmailModal";
import LeadDetails from "../views/AllApprovals/CustomerLeadApproval/LeadDetails";

import { BillingConfiguration } from "../views/BillingConfiguration";

import AllApprovals from "../views/AllApprovals";
import AllMasterLists from "../views/Master/MasterLists";

import MasterSigleCpView from "../views/Master/MasterListView/MasterCpView";
import MasterSigleClientView from "../views/Master/MasterListView/MasterClientView";
import MasterSigleUserView from "../views/Master/MasterListView/MasterUserView";

import RequestBranch from "../views/RequestBranch/index";

import Broadcast from "../views/Broadcast";

import StaffOnboarding from "../views/onboarding_/StaffOnboarding";
import constants from "../constants/constants";

import "antd/dist/antd.css";
import "../App.scss";
import RateCardList from "../views/RateCardList";
import CrediteBooking from "../views/FirstMile/CrediteBooking";
import ClientCrediteBooking from "../views/FirstMile/CrediteBooking";

import Discount from "../views/FirstMile/RetailBooking/ApplyDiscount";
import DiscountedList from "../views/FirstMile/RetailBooking/DiscountedList";
import NewRetailUX from "../views/FirstMile/RetailBooking/NewRetailUX";
import ShipmentTracker from "../views/ShipmentTracker";
import CPWiseHubManifestEWayBill from "../views/EwayBill/CPWiseHubManifestEWayBill";
import LCRThreshold from "../views/LCRThreshold";
import ClientOnboarding from "../views/onboarding_/ClientOnboarding";
import ClientTable from "../views/onboarding_/ClientOnboarding/viewClientTable";
import ViewClientDetails from "../views/onboarding_/ClientOnboarding/ViewClientDetails";
import CPMasterLists from "../views/CPMasterList";
import BulkBooking from "../views/FirstMile/BulkBooking";
import ViewSeries from "../views/ViewSeries";
import RateCards from "../views/RateCalculator/RateCards";
import RateCalculator from "../views/RateCalculator/RateCalculator";
import MultiPrint from "../views/PrintBooking/MultiPrint";
import LeadCPApprovalConfirmation from "../components/NewRateEngine/NewRateCard";
import CustomerDetails from "../components/CustomerDetails";

import DRS from "../views/DRS";
import OpenDRS from "../views/OpenDRS";
import CpDrsDetails from "../views/DRS/CpDrsDetails";
import PendingAwbs from "../views/DRS/PendingAwbs";
import CpDrsPodUpload from "../views/DRS/CpDrsPodUpload";
import CpDrsDeliveryUpdate from "../views/DRS/CpDrsDeliveryUpdate";
import CpPrsDetails from "../views/PRS/CpPrsDetails";
import PRS from "../views/PRS";
import DAManagement from "../views/DAManagement";
import AreaManagement from "../views/AreaManagement";
import DAHotspotManagement from "../views/DAHotspotManagement";
import DAAttendance from "../views/DAAttendance";
import DAAttendanceNew from "../views/DAAttendanceNew";
import CODCenterOnboarding from "../views/CODCenterOnboarding";
import AllReports from "../views/Report/AllReports";
import DynamicRateMatrix from "../components/DynamicRateMatrix";
import UndeliveredShipments from "../views/UndeliveredShipments";
import ViewShipmentDetails from "../views/UndeliveredShipments/ViewShipmentDetails";
import ViewRTOShipmentDetails from "../views/RTORequests/ViewRTOShipmentDetails";
import DeliveredPODUpload from "../views/RTORequests/DeliveredPODUpload";

import DefaultRateCard from "../views/RateCardConfigMaster/DefaultRateCard";
import MasterRateCard from "../views/RateCardConfigMaster/MasterRateCard";
import KYCForm from "../views/KYCCompo";
import RTOShipments from "../views/RTORequests";
import Hubs from "../views/Hubs";
import DeliveryPartner from "../views/DeliveryPartner";
import DPPincode from "../views/DPPincode";
import Wallet from "../views/Wallet";
import RateCardMatrix from "../views/DynamicRateCard/DynamicRateCardMatrix";
import ZoneManagement from "../views/ZoneManagement";
import PendingPRSMapping from "../views/PendingPRSMapping";
import CPKYC from "../views/NewKYC/index";

import PrintConsolidatedManifest from "../views/FirstMile/PrintConsolidatedManifest";
import EcommOnboarding from "../views/EcommOnboarding";
import CargoOnboarding from "../views/CargoOnboarding";
import Reports from "../views/Reports";
import HoViewBooking from "../views/viewBookingTable/Listing_HO";

import NotificationManagement from "../views/NotificationManagement";

import DeliveryMISReport from "../views/Reports/DeliveryMISReport";
import ReportDetails from "../views/Reports/ReportDetails";
import ODADRSStatusUpdate from "../views/Reports/ODADRSStatusUpdate";
import PRSAnalytics from "../views/PRSAnalytics";
import AnomaliesReport from "../views/AnomaliesReport";
import InScan from "../views/InScan";
// import OutScan from "../views/OutScan";
import NewOutScan from "../views/OutScan/NewOutScan";
import PRSStatusDetails from "../views/PRSAnalytics/PRSStatusDetails";
import UnbookedShipmentsReport from "../views/Reports/UnbookedShipmentsReport";
import IframeShipmentTracker from "../views/ShipmentTracker/IframeShipmentTracker";
import PincodeManagement from "../components/PincodeManagement";
import LockingManagementDashboard from "../views/LockingManagementDashboard";
import VayuQuickPincodeMapping from "../components/VayuQuickPincodeMapping";
import DADataPage from "../views/DAdata";
import LockedShipments from "../views/LockedShipments";
import TrainingVideo from "../views/TrainingVideo";
import DRSClickableDetail from "../views/Reports/DRSClickableDetail";
import CPPendancyReport from "../views/Reports/CPPendancyReport";
import DRSStatusReport from "../views/Reports/DRSStatusReport";
import DRSPerformanceReport from "../views/Reports/DRSPerformanceReport";
import HubOutscanCPInscanReport from "../views/Reports/HubOutscanCPInscanReport";
import DeliveryMISReportNew from "../views/Reports/DeliveryMISReportNew";
import DAProductivityReport from "../views/Reports/DAProductivityReport";
import DeliveryInvoiceList from "../views/DeliveryInvoiceList";
import DeliveryInvoiceReport from "../views/DeliveryInvoiceReport";

const { ROLES } = constants;
const {
  CP_ADMIN,
  HO_ADMIN,
  HUB_ADMIN,
  ROLE_HOMARKETING,
  CP_OPERATOR,
  CP_BOOKINGONLY,
  CLIENT_ADMIN,
  DP_OPERATOR,
  HO_LEGAL,
  HO_FINANCE,
  CENTRALOPERATOR,
  CENTRALOPS_ADMIN,
  MIS_EXECUTIVE,
  SNO_MANAGER,
  ROLE_COSNO,
  ROLE_COLANDD,
  ROLE_REPORTSADMIN,
} = ROLES;

export const routeList = [
  {
    component: DRSClickableDetail,
    route: "/drs-clickable-detail",
    role: [
      CENTRALOPS_ADMIN,
      MIS_EXECUTIVE,
      CP_ADMIN,
      CP_OPERATOR,
      ROLE_REPORTSADMIN,
    ],
  },
  {
    component: BookingTabs,
    route: "/viewBooking",
    role: [CP_ADMIN, CP_OPERATOR, CP_BOOKINGONLY, CLIENT_ADMIN],
  },
  {
    component: BulkBooking,
    route: "/bulk-booking",
    role: [CP_ADMIN, CP_OPERATOR, CP_BOOKINGONLY, CLIENT_ADMIN],
  },
  {
    component: ViewSeries,
    route: "/search-series",
    role: [CP_ADMIN, CLIENT_ADMIN],
  },
  {
    component: Settings,
    route: "/settings",
    role: [CP_ADMIN, CLIENT_ADMIN],
  },
  {
    component: CpLeadGen,
    route: "/cp-lead-generation",
    role: [ROLE_HOMARKETING],
  },

  {
    component: CPLeadList,
    route: "/cp-lead-generation-list",
    role: [ROLE_HOMARKETING],
  },
  {
    component: ClientLeadList,
    route: "/client-lead-generation-list",
    role: [CP_ADMIN, ROLE_HOMARKETING, CLIENT_ADMIN],
  },
  {
    component: ClientLeadList,
    route: "/dp-lead-generation-list",
    role: [ROLE_HOMARKETING],
  },
  {
    component: ClientLeadGeneration,
    route: "/client-lead-generation/:id",
    role: [HUB_ADMIN, CP_ADMIN, HO_ADMIN, ROLE_HOMARKETING, CLIENT_ADMIN],
  },
  {
    component: ClientLeadGeneration,
    route: "/client-lead-generation",
    role: [HUB_ADMIN, CP_ADMIN, HO_ADMIN, ROLE_HOMARKETING, CLIENT_ADMIN],
  },

  {
    component: ClientQuotationList,
    route: "/quotation-list/:id",
    role: [HUB_ADMIN, CP_ADMIN, HO_ADMIN, ROLE_HOMARKETING],
    ROLE_HOMARKETING,
  },
  {
    component: HoViewBooking,
    route: "/ho-view-booking",
    role: [HO_ADMIN],
  },
  {
    component: CPQuotationList,
    route: "/cp-quotation-list/:id",
    role: [
      HUB_ADMIN,
      CP_ADMIN,
      HO_ADMIN,
      ROLE_HOMARKETING,
      HO_FINANCE,
      HO_LEGAL,
    ],
    ROLE_HOMARKETING,
  },
  {
    component: NewQuotation,
    route: "/client/:clientId/new-quotation/:id/status/:status",
    role: [HUB_ADMIN, CP_ADMIN, HO_ADMIN, ROLE_HOMARKETING],
  },
  {
    component: NewQuotation,
    route: "/new-quotation/:clientId",
    role: [HUB_ADMIN, CP_ADMIN, HO_ADMIN, ROLE_HOMARKETING],
  },

  {
    component: CPNewQuotation,
    route: "/cp-quotation-new/:id",
    role: [HUB_ADMIN, CP_ADMIN, HO_ADMIN, ROLE_HOMARKETING],
  },
  {
    component: CPNewQuotation,
    route: "/cp-quotation-edit/:id",
    role: [HUB_ADMIN, CP_ADMIN, HO_ADMIN, ROLE_HOMARKETING],
  },
  {
    component: AllApprovals,
    route: "/all-approvals",
    role: [HUB_ADMIN, HO_ADMIN, HO_LEGAL, HO_FINANCE],
  },
  {
    component: AllMasterLists,
    route: "/master-list",
    role: [HO_ADMIN],
  },
  {
    component: CPMasterLists,
    route: "/cp-master-list",
    role: [CP_ADMIN],
  },
  {
    component: MasterSigleCpView,
    route: "/master-cp-details/:id",
    role: [HO_ADMIN],
  },
  {
    component: MasterSigleClientView,
    route: "/master-client-details/:id",
    role: [HO_ADMIN],
  },
  {
    component: MasterSigleUserView,
    route: "/master-user-details/:id",
    role: [HO_ADMIN],
  },
  {
    component: PrsGenerationTab,
    route: "/prs-generation",
    role: [HUB_ADMIN],
  },

  {
    component: CPEWayBill,
    route: "/cp-eway-bill/:id",
    role: [CP_ADMIN, CP_OPERATOR, HUB_ADMIN, HO_ADMIN, CP_BOOKINGONLY],
  },
  {
    component: HubManifestEWayBill,
    route: "/hub-manifest-eway/:id",
    role: [CP_ADMIN, CP_OPERATOR, HUB_ADMIN, HO_ADMIN, CP_BOOKINGONLY],
  },
  {
    component: LastMileEWayBill,
    route: "/last-mile-eway-bill/:id",
    role: [CP_ADMIN, CP_OPERATOR, HUB_ADMIN, HO_ADMIN, CP_BOOKINGONLY],
  },
  {
    component: HubEWayBill,
    route: "/hub-eway-bill/:id",
    role: [CP_ADMIN, HUB_ADMIN, HO_ADMIN],
  },
  {
    component: ExtendEWayBill,
    route: "/extend-eway",
    role: [CP_ADMIN, HUB_ADMIN, HO_ADMIN],
  },

  {
    component: NewRetailUX,
    route: "/retail-booking",
    role: [CP_ADMIN, CP_OPERATOR, CP_BOOKINGONLY],
  },
  {
    component: ScanedandManifestList,
    route: "/scan",
    role: [CP_ADMIN, CP_OPERATOR, CP_BOOKINGONLY],
  },
  {
    component: ChildPacketScan,
    route: "/child-scan",
    role: [CP_ADMIN, CP_OPERATOR, CP_BOOKINGONLY],
  },
  {
    component: PrintConsolidatedManifest,
    route: "/print/:id",
    role: [CP_ADMIN, HO_ADMIN, HUB_ADMIN, CP_OPERATOR, CP_BOOKINGONLY],
  },
  {
    component: Master,
    route: "/last-mile-operations",
    role: [CP_ADMIN, CP_OPERATOR, CP_BOOKINGONLY],
  },
  {
    component: InScanCP,
    route: "/in-scan-cp",
    role: [CP_ADMIN, CP_OPERATOR, CP_BOOKINGONLY],
  },
  {
    component: CreateVirtualArea,
    route: "/create-virtual-area",
    role: [CP_ADMIN],
  },
  {
    component: AddPacketMapping,
    route: "/addpacket-mapping",
    role: [HO_ADMIN],
  },
  {
    component: ViewManifest,
    route: "/view-manifest",
    role: [CP_ADMIN, CP_OPERATOR, CP_BOOKINGONLY],
  },
  {
    component: PrintBooking,
    route: "/print-booking/:id",
    role: [CP_ADMIN, CP_OPERATOR, CP_BOOKINGONLY],
  },
  {
    component: MultiPrint,
    route: "/multi-print-booking",
    role: [CP_ADMIN, CP_OPERATOR, CP_BOOKINGONLY, CLIENT_ADMIN],
  },
  {
    component: Truck,
    route: "/truck/:id",
    role: [CP_ADMIN, CP_OPERATOR, CP_BOOKINGONLY],
  },
  {
    component: NewTruck,
    route: "/new-truck",
    role: [CP_ADMIN, CP_OPERATOR, CP_BOOKINGONLY],
  },
  {
    component: PacketingCP,
    route: "/cp-packeting",
    role: [CP_ADMIN, CP_OPERATOR, CP_BOOKINGONLY],
  },

  {
    component: NewBookedSuccessfull,
    route: "/retail-booking-success",
    role: [CP_ADMIN, CP_OPERATOR, CP_BOOKINGONLY],
  },
  {
    component: Master,
    route: "/masters",
    role: [HO_ADMIN, HUB_ADMIN],
  },
  {
    component: DefaultRateCard,
    route: "/default-ratecard",
    role: [HO_ADMIN],
  },
  {
    component: MasterRateCard,
    route: "/default-ratecard/:id",
    role: [HO_ADMIN],
  },
  {
    component: AllocateTemplate,
    route: "/allocate-template",
    role: [HO_ADMIN],
  },
  {
    component: AllocateTemplate,
    route: "/account-allocate-template",
    role: [HO_ADMIN],
  },
  {
    component: RouteMaster,
    route: "/route-configuration",
    role: [HO_ADMIN, HUB_ADMIN],
  },
  {
    component: HubRouteMaster,
    route: "/hub-route-configuration",
    role: [HUB_ADMIN],
  },
  {
    component: FirstAndLastMileTAT,
    route: "/first-last-mile-tat",
    role: [HO_ADMIN],
  },
  {
    component: CPKYC,
    route: "/cp-kyc",
    role: [HO_ADMIN, CP_ADMIN],
  },
  {
    component: PincodeMaster,
    route: "/pincode-master",
    role: [HO_ADMIN],
  },
  {
    component: CpLeadGen,
    route: "/cp-onboarding",
    role: [HO_ADMIN, CP_ADMIN],
  },
  {
    component: VehicleOnboard,
    route: "/vehicle-onboard",
    role: [CP_ADMIN, HUB_ADMIN],
  },
  {
    component: MiddleMileTAT,
    route: "/middle-mile-tat",
    role: [HO_ADMIN],
  },
  {
    component: MasterChild,
    route: "/master-card-child",
    role: [HO_ADMIN, CP_ADMIN],
  },
  {
    component: PacketingGuide,
    route: "/packeting-guide",
    role: [HO_ADMIN],
  },
  {
    component: PinCodeMapping,
    route: "/pin-code-mapping",
    role: [HO_ADMIN],
  },

  {
    component: Broadcast,
    route: "/message-and-alerts",
    role: [HO_ADMIN],
  },
  {
    component: Master,
    route: "/onboarding-settings",
    role: [
      HO_ADMIN,
      CP_ADMIN,
      HUB_ADMIN,
      ROLE_HOMARKETING,
      CLIENT_ADMIN,
      HO_LEGAL,
      HO_FINANCE,
    ],
  },

  {
    component: Master,
    route: "/middle-mile",
    role: [HUB_ADMIN],
  },
  {
    component: Master,
    route: "/hub-in-scan",
    role: [HUB_ADMIN],
  },
  {
    component: printEwayBill,
    route: "/print-eway-bill",
    role: [HUB_ADMIN, CP_ADMIN, CP_OPERATOR, CP_BOOKINGONLY, CLIENT_ADMIN],
  },
  {
    component: Master,
    route: "/configuration-guide",
    role: [HUB_ADMIN],
  },

  {
    component: Audits,
    route: "/audits",
    role: [HUB_ADMIN],
  },
  {
    component: HubOnboarding,
    route: "/hub-onboarding",
    role: [HO_ADMIN],
  },

  {
    component: SortingGuide,
    route: "/sorting-guide",
    role: [HO_ADMIN, HUB_ADMIN],
  },

  {
    component: StaffOnboarding,
    route: "/staff-onboarding",
    role: [HO_ADMIN, CP_ADMIN, HUB_ADMIN, CLIENT_ADMIN],
  },

  {
    component: DrsGeneration,
    route: "/generate-drs",
    role: [CP_ADMIN],
  },
  {
    component: printDrs,
    route: "/print-drs",
    role: [CP_ADMIN],
  },
  {
    component: DrsDetails,
    route: "/drs-details",
    role: [CP_ADMIN],
  },
  {
    component: PendingDrs,
    route: "/pending-drs",
    role: [CP_ADMIN],
  },

  // deepak's rout

  {
    component: PrintGenerateManifest,
    route: "/print-generate-manifest/:id",
    role: [CP_ADMIN, HUB_ADMIN, HO_ADMIN, CLIENT_ADMIN],
  },

  {
    component: VehicleList,
    route: "/vehicle-list",
    role: [HUB_ADMIN, HO_ADMIN, ROLE_REPORTSADMIN],
  },
  {
    component: VehicleCkinCkout,
    route: "/vehicle-checkin-checkout",
    role: [HUB_ADMIN, ROLE_REPORTSADMIN],
  },
  {
    component: TripListByVehicle,
    route: "/vehicle-trip-list",
    role: [HUB_ADMIN, HO_ADMIN, ROLE_REPORTSADMIN],
  },
  {
    component: Master,
    route: "/reports",
    role: [HUB_ADMIN],
  },

  {
    component: TatConfiguration,
    route: "/tat-config",
    role: [HO_ADMIN],
  },
  {
    component: TatCalulator,
    route: "/tat-calculator",
    role: [HO_ADMIN],
  },
  {
    component: VehicleMaster,
    route: "/vehicle-master",
    role: [HUB_ADMIN, HO_ADMIN],
  },
  // {
  //   component: ExcessInscan,
  //   route: "/excess-misrouted",
  //   role: [HUB_ADMIN, HO_ADMIN],
  // },

  // cashRTo
  {
    component: CashRTo,
    route: "/cash-rto/:id",
    role: [HUB_ADMIN, HO_ADMIN, CP_ADMIN],
  },
  {
    component: CreditRTO,
    route: "/credit-rto/:id",
    role: [HUB_ADMIN, HO_ADMIN, CP_ADMIN],
  },

  {
    component: LeadDetails,
    route: "/lead-details/:status/:leadId",
    role: [CP_ADMIN, HUB_ADMIN, HO_ADMIN, ROLE_HOMARKETING],
  },
  {
    component: LeadCPApprovalConfirmation,
    route: "/lead-cp-approval-confirmation/:status/:leadId",
    role: [
      CP_ADMIN,
      HUB_ADMIN,
      HO_ADMIN,
      ROLE_HOMARKETING,
      HO_ADMIN,
      HO_FINANCE,
      HO_LEGAL,
    ],
  },
  {
    component: CustomerDetails,
    route: "/customer-details/:id",
    role: [CP_ADMIN, HO_ADMIN, ROLE_HOMARKETING, HO_FINANCE, HO_LEGAL],
  },
  {
    component: CpOnboardingNew,
    route: "cp-details",
    // route: "/manifest-tracker/:id",

    role: [CP_ADMIN, HUB_ADMIN, HO_ADMIN],
  },
  {
    component: CompanyBranch,
    route: "/company-branch",
    role: [CP_ADMIN, CP_OPERATOR, CP_BOOKINGONLY],
  },
  {
    component: ScheduleMeetingModal,
    route: "schedule-meeting",
    // route: "/manifest-tracker/:id",

    role: [CP_ADMIN, HUB_ADMIN, HO_ADMIN],
  },
  {
    component: SendEmailModal,
    route: "send-mail",
    role: [CP_ADMIN, HUB_ADMIN, HO_ADMIN],
  },
  {
    component: StateMaster,
    route: "/add-state-master",
    role: [HO_ADMIN],
  },

  {
    component: BillingConfiguration,
    route: "/billing-config",
    role: [CP_ADMIN, HUB_ADMIN, HO_ADMIN],
  },
  {
    component: RateCardList,
    route: "/rate-card-list",
    role: [CP_ADMIN, HUB_ADMIN, HO_ADMIN],
  },
  {
    component: KycView,
    route: "kyc-view",
    role: [CP_ADMIN, HUB_ADMIN, HO_ADMIN, ROLE_HOMARKETING],
  },
  {
    component: RequestBranch,
    route: "request-for-branch",
    role: [CP_ADMIN, HUB_ADMIN, HO_ADMIN, ROLE_HOMARKETING],
  },
  {
    component: CrediteBooking,
    route: "credit-booking",
    role: [
      CP_ADMIN,
      HUB_ADMIN,
      HO_ADMIN,
      ROLE_HOMARKETING,
      CP_OPERATOR,
      CP_BOOKINGONLY,
      // CLIENT_ADMIN,
    ],
  },
  {
    component: CrediteBooking,
    route: "ocr-bookings/:date/:id/:type",
    role: [
      CP_ADMIN,
      HO_ADMIN,
      ROLE_HOMARKETING,
      CP_OPERATOR,
      CP_BOOKINGONLY,
      CLIENT_ADMIN,
    ],
  },
  {
    component: CrediteBooking,
    route: "api-bookings/:date/:id/:type",
    role: [
      CP_ADMIN,
      HO_ADMIN,
      ROLE_HOMARKETING,
      CP_OPERATOR,
      CP_BOOKINGONLY,
      CLIENT_ADMIN,
    ],
  },
  {
    component: ClientCrediteBooking,
    route: "client-credit-booking",
    role: [CLIENT_ADMIN],
  },
  {
    component: CrediteBooking,
    route: "credit-booking-edit/:date/:id",
    role: [
      CP_ADMIN,
      HUB_ADMIN,
      HO_ADMIN,
      ROLE_HOMARKETING,
      CP_OPERATOR,
      CP_BOOKINGONLY,
      CLIENT_ADMIN,
    ],
  },

  {
    component: NewRetailUX,
    route: "retail-booking-edit/:id",
    role: [
      CP_ADMIN,
      HUB_ADMIN,
      HO_ADMIN,
      ROLE_HOMARKETING,
      CP_OPERATOR,
      CP_BOOKINGONLY,
      CLIENT_ADMIN,
    ],
  },

  //--//

  //--Middle Mile--//
  // {
  //   component: InScan,
  //   route: "/in-scan/:id",
  //   // route: "/manifest-in-scan",
  //   role: [HUB_ADMIN],
  // },
  // {
  //   component: AllManifestInScan,
  //   route: "/manifest-in-scan",
  //   // route: "/manifest-in-scan",
  //   role: [HUB_ADMIN],
  // },

  // {
  //   component: LCRBagInScan,
  //   route: "/lcr-bag-scan/:id",
  //   role: [HUB_ADMIN],
  // },

  // {
  //   component: OpenBag,
  //   route: "/lcr-bag-open/:id",
  //   role: [HUB_ADMIN],
  // },

  {
    component: ClientOnboarding,
    route: "/client-onboarding",
    role: [CP_ADMIN],
  },
  {
    component: ClientTable,
    route: "/client-list",
    role: [CP_ADMIN, HO_ADMIN],
  },
  {
    component: ViewClientDetails,
    route: "/view-client/:id",
    role: [CP_ADMIN, HO_ADMIN],
  },

  // {
  //   component: OnborginTabs,
  //   route: "/cp-onboarding",
  //   role: ["ROLE_HOADMIN"],
  // },
  // {
  //   component: Guides,
  //   route: "/guides",
  //   role: [HUB_ADMIN],
  // },
  // {
  //   component: ViewDetails,
  //   route: "/view-details",
  //   role: [HO_ADMIN, CP_ADMIN],
  // },
  // {
  //   component: Stationary,
  //   route: "/stationery",
  //   role: [HO_ADMIN, CP_ADMIN, HUB_ADMIN],
  // },

  //stationary
  {
    component: HoStationary,
    route: "/stationery",
    role: [HO_ADMIN, HUB_ADMIN, CP_ADMIN],
  },
  {
    component: AddCategory,
    route: "/add-category",
    role: [HO_ADMIN],
  },
  {
    component: AddProduct,
    route: "/add-product",
    role: [HO_ADMIN],
  },
  {
    component: ProductTabs,
    route: "/product",
    role: [HO_ADMIN],
  },

  {
    component: ProductCP,
    route: "/product-list",
    role: [CP_ADMIN, HUB_ADMIN],
  },
  {
    component: ProductDetails,
    route: "/product-details/:id",
    role: [CP_ADMIN, HUB_ADMIN],
  },
  {
    component: CartPage,
    route: "/cart-details",
    role: [CP_ADMIN, HUB_ADMIN],
  },
  {
    component: OrderRequest,
    route: "/order-request",
    role: [HO_ADMIN],
  },
  {
    component: OrderDetailsHo,
    route: "/order-detail/:id",
    role: [HO_ADMIN],
  },
  {
    component: OrderHistory,
    route: "/order-history",
    role: [CP_ADMIN, HUB_ADMIN],
  },
  {
    component: OrderDetails,
    route: "/order-details/:id",
    role: [CP_ADMIN, HUB_ADMIN, HO_ADMIN],
  },

  {
    component: Discount,
    route: "/retail-discount",
    role: [CP_ADMIN],
  },
  {
    component: DiscountedList,
    route: "/retail-discounted-list",
    role: [CP_ADMIN],
  },
  {
    component: NewRetailUX,
    route: "/new-retail-ux",
    role: [CP_ADMIN],
  },

  {
    component: CPWiseHubManifestEWayBill,
    route: "/cp-wise-Eway/:id",
    role: [HUB_ADMIN],
  },

  {
    component: PrintManifest,
    route: "/cp-wise-manifest-print/:id",
    role: [HUB_ADMIN],
  },

  // {
  //   component: ShipmentTracker,
  //   route: "/shipment-tracker",
  //   role: [
  //     HO_ADMIN,
  //     HUB_ADMIN,
  //     CP_ADMIN,
  //     CLIENT_ADMIN,
  //     CP_OPERATOR,
  //     ROLE_HOMARKETING,
  //     DP_OPERATOR,
  //     CENTRALOPS_ADMIN,
  //     MIS_EXECUTIVE,
  //     SNO_MANAGER,
  //     CENTRALOPERATOR,
  //   ],
  // },
  {
    component: ShipmentTracker,
    route: "/shipment-tracker",
    role: [
      HO_ADMIN,
      HUB_ADMIN,
      CP_ADMIN,
      CLIENT_ADMIN,
      CP_OPERATOR,
      ROLE_HOMARKETING,
      DP_OPERATOR,
      CENTRALOPS_ADMIN,
      MIS_EXECUTIVE,
      SNO_MANAGER,
      CENTRALOPERATOR,
    ],
  },

  {
    component: LCRThreshold,
    route: "/lcr-threshold",
    role: [HO_ADMIN],
  },
  // {
  //   component: CashRateCard,
  //   route: "/cash-ratecard",
  //   role: [CP_ADMIN],
  // },
  {
    component: RateCards,
    route: "/ratecards",
    role: [CP_ADMIN, HO_ADMIN],
  },
  {
    component: RateCalculator,
    route: "/rate-calculator",
    role: [CP_ADMIN, CLIENT_ADMIN],
  },
  {
    component: DRS,
    route: "/drs",
    role: [CP_ADMIN, CP_OPERATOR, CP_BOOKINGONLY, DP_OPERATOR],
  },
  {
    component: OpenDRS,
    route: "/open-drs",
    role: [CP_ADMIN, CP_OPERATOR, CP_BOOKINGONLY, DP_OPERATOR],
  },
  {
    component: CpDrsDetails,
    route: "/cp-drs-details/:id",
    role: [CP_ADMIN, CP_OPERATOR, CP_BOOKINGONLY, DP_OPERATOR],
  },
  {
    component: CpDrsPodUpload,
    route: "/cp-drs-pod-upload/:id",
    role: [CP_ADMIN, CP_OPERATOR, CP_BOOKINGONLY, DP_OPERATOR],
  },
  {
    component: CpDrsDeliveryUpdate,
    route: "/cp-drs-delivery-update",
    role: [CP_ADMIN, CP_OPERATOR, CP_BOOKINGONLY, DP_OPERATOR],
  },
  {
    component: PRS,
    route: "/prs",
    role: [CP_ADMIN, CP_OPERATOR, CP_BOOKINGONLY, DP_OPERATOR, HO_ADMIN],
  },
  {
    component: CpPrsDetails,
    route: "/prs-details/:id",
    role: [
      CP_ADMIN,
      CP_OPERATOR,
      CP_BOOKINGONLY,
      DP_OPERATOR,
      CENTRALOPS_ADMIN,
      MIS_EXECUTIVE,
      HO_ADMIN,
    ],
  },
  {
    component: DAManagement,
    route: "/da-management",
    role: [CP_ADMIN, CP_OPERATOR, DP_OPERATOR, ROLE_COSNO],
  },
  {
    component: AreaManagement,
    route: "/area-management",
    role: [CP_ADMIN, CP_OPERATOR, DP_OPERATOR, ROLE_COSNO],
  },
  {
    component: DAHotspotManagement,
    route: "/da-hotspot-management",
    role: [CENTRALOPS_ADMIN, SNO_MANAGER],
  },
  {
    component: AllReports,
    route: "/all-report",
    role: [CP_ADMIN, HO_ADMIN, ROLE_REPORTSADMIN],
  },
  {
    component: DynamicRateMatrix,
    route: "/rate-card-config",
    role: [CP_ADMIN, HO_ADMIN],
  },
  {
    component: UndeliveredShipments,
    route: "/undelivered-shipments",
    role: [DP_OPERATOR],
  },
  {
    component: ViewShipmentDetails,
    route: "/shipments-details/:id",
    role: [DP_OPERATOR],
  },
  {
    component: ViewRTOShipmentDetails,
    route: "/rto-shipments-details/:id",
    role: [CENTRALOPERATOR],
  },
  {
    component: KYCForm,
    route: "/new-kyc",
    role: [CP_ADMIN, HO_ADMIN, CLIENT_ADMIN],
  },
  {
    component: RTOShipments,
    route: "/rto-shipments",
    role: [CENTRALOPERATOR],
  },
  {
    component: DeliveredPODUpload,
    route: "/delivered-pod-upload",
    role: [CENTRALOPERATOR],
  },
  {
    component: Hubs,
    route: "/hubs",
    role: [CENTRALOPS_ADMIN],
  },
  {
    component: DeliveryPartner,
    route: "/delivery-partner",
    role: [CENTRALOPS_ADMIN],
  },
  {
    component: DPPincode,
    route: "/dp-pincode",
    role: [CENTRALOPS_ADMIN],
  },
  {
    component: Wallet,
    route: "/my-wallet",
    role: [CP_ADMIN, HO_ADMIN],
  },
  {
    component: RateCardMatrix,
    route: "/rates",
    role: [CP_ADMIN, HO_ADMIN],
  },
  {
    component: ZoneManagement,
    route: "/zone-management",
    role: [CP_ADMIN, HO_ADMIN],
  },
  {
    component: PendingPRSMapping,
    route: "/pending-prs-mapping",
    role: [CENTRALOPS_ADMIN],
  },
  {
    component: EcommOnboarding,
    route: "/ecomm-onboarding",
    role: [CENTRALOPS_ADMIN, MIS_EXECUTIVE],
  },
  {
    component: CargoOnboarding,
    route: "/cargo-onboarding",
    role: [CENTRALOPS_ADMIN],
  },
  {
    component: Reports,
    route: "/mis-reports",
    role: [CP_ADMIN, HUB_ADMIN, HO_ADMIN, ROLE_REPORTSADMIN],
  },
  {
    component: DeliveryMISReport,
    route: "/delivery-mis-report",
    role: [CP_ADMIN, HUB_ADMIN, HO_ADMIN, ROLE_REPORTSADMIN],
  },
  {
    component: NotificationManagement,
    route: "/notification-manage",
    role: [HO_ADMIN],
  },
  {
    component: ReportDetails,
    route: "/delivery-mis-report/report-details",
    role: [CP_ADMIN, HUB_ADMIN, HO_ADMIN, ROLE_REPORTSADMIN],
  },
  {
    component: CODCenterOnboarding,
    route: "/cod-center-onboarding",
    role: [DP_OPERATOR],
  },
  {
    component: PRSAnalytics,
    route: "/prs-analytics",
    role: [
      CENTRALOPS_ADMIN,
      MIS_EXECUTIVE,
      DP_OPERATOR,
      CENTRALOPERATOR,
      ROLE_REPORTSADMIN,
    ],
  },
  {
    component: ODADRSStatusUpdate,
    route: "/oda-drs-status-update-adoption-report",
    role: [
      CP_ADMIN,
      HO_ADMIN,
      HUB_ADMIN,
      CP_OPERATOR,
      CP_BOOKINGONLY,
      DP_OPERATOR,
      CENTRALOPERATOR,
      CENTRALOPS_ADMIN,
      MIS_EXECUTIVE,
      SNO_MANAGER,
      CLIENT_ADMIN,
      ROLE_HOMARKETING,
      HO_LEGAL,
      HO_FINANCE,
      ROLE_REPORTSADMIN,
    ],
  },
  {
    component: AnomaliesReport,
    route: "/anomalies-report",
    role: [
      CP_ADMIN,
      HO_ADMIN,
      HUB_ADMIN,
      CP_OPERATOR,
      CP_BOOKINGONLY,
      DP_OPERATOR,
      CENTRALOPERATOR,
      CENTRALOPS_ADMIN,
      MIS_EXECUTIVE,
      SNO_MANAGER,
      CLIENT_ADMIN,
      ROLE_HOMARKETING,
      HO_LEGAL,
      HO_FINANCE,
      ROLE_REPORTSADMIN,
    ],
  },
  {
    component: DAAttendance,
    route: "/da-attendance",
    role: [CENTRALOPS_ADMIN, SNO_MANAGER],
  },
  {
    component: DAAttendanceNew,
    route: "/da-attendance-new",
    role: [CENTRALOPS_ADMIN, SNO_MANAGER, ROLE_COSNO, ROLE_COLANDD],
  },
  {
    component: InScan,
    route: "/in-scan",
    role: [CP_ADMIN, CP_OPERATOR, DP_OPERATOR],
  },
  {
    component: NewOutScan,
    route: "/out-scan",
    role: [CP_ADMIN, CP_OPERATOR],
  },
  {
    component: PRSStatusDetails,
    route: "/prs-analytics/status/:status",
    role: [CENTRALOPS_ADMIN, MIS_EXECUTIVE, DP_OPERATOR, ROLE_REPORTSADMIN],
  },
  {
    component: UnbookedShipmentsReport,
    route: "/unbooked-shipments-report",
    role: [CENTRALOPS_ADMIN, ROLE_REPORTSADMIN],
  },
  {
    component: PincodeManagement,
    route: "/pincode-management",
    role: [CENTRALOPS_ADMIN, CENTRALOPERATOR],
  },
  {
    component: VayuQuickPincodeMapping,
    route: "/vayuquick-pincode-management",
    role: [CENTRALOPS_ADMIN, CENTRALOPERATOR],
  },
  {
    component: DADataPage,
    route: "/da-data",
    role: [CENTRALOPS_ADMIN, SNO_MANAGER, ROLE_COSNO],
  },
  {
    component: LockedShipments,
    route: "/locked-shipments",
    role: [CENTRALOPS_ADMIN, CP_ADMIN, CP_OPERATOR],
  },
  {
    component: TrainingVideo,
    route: "/training-videos",
    role: [
      CP_ADMIN,
      HO_ADMIN,
      HUB_ADMIN,
      CP_OPERATOR,
      CP_BOOKINGONLY,
      CLIENT_ADMIN,
      ROLE_HOMARKETING,
      DP_OPERATOR,
      HO_LEGAL,
      HO_FINANCE,
      CENTRALOPERATOR,
      CENTRALOPS_ADMIN,
      MIS_EXECUTIVE,
      SNO_MANAGER,
    ],
  },
  // {
  //   component: NewOutScan,
  //   route: "/new-out-scan",
  //   role: [CP_ADMIN, CP_OPERATOR],
  // },
  {
    component: CPPendancyReport,
    route: "/cp-pendancy-report",
    role: [
      CENTRALOPS_ADMIN,
      MIS_EXECUTIVE,
      CP_ADMIN,
      CP_OPERATOR,
      ROLE_REPORTSADMIN,
    ],
  },
  {
    component: DRSPerformanceReport,
    route: "/drs-performance-report",
    role: [
      CENTRALOPS_ADMIN,
      MIS_EXECUTIVE,
      CP_ADMIN,
      CP_OPERATOR,
      DP_OPERATOR,
      ROLE_COLANDD,
      ROLE_REPORTSADMIN,
    ],
  },
  {
    component: HubOutscanCPInscanReport,
    route: "/hub-outscan-cp-inscan-report",
    role: [
      CENTRALOPS_ADMIN,
      MIS_EXECUTIVE,
      CP_ADMIN,
      CP_OPERATOR,
      ROLE_REPORTSADMIN,
    ],
  },
  {
    component: DAProductivityReport,
    route: "/da-productivity-report",
    role: [CENTRALOPS_ADMIN, ROLE_COLANDD, ROLE_REPORTSADMIN],
  },
  {
    component: DRSStatusReport,
    route: "/drs-status-report",
    role: [
      CENTRALOPS_ADMIN,
      MIS_EXECUTIVE,
      CP_ADMIN,
      CP_OPERATOR,
      DP_OPERATOR,
      ROLE_REPORTSADMIN,
    ],
  },
  {
    component: DeliveryMISReportNew,
    route: "/delivery-mis-report-new",
    role: [
      CENTRALOPS_ADMIN,
      MIS_EXECUTIVE,
      CP_ADMIN,
      CP_OPERATOR,
      DP_OPERATOR,
      ROLE_REPORTSADMIN,
    ],
  },
  {
    component: DeliveryInvoiceList,
    route: "/delivery-invoice-list",
    role: [HO_ADMIN, CP_ADMIN, CP_OPERATOR],
  },
  {
    component: DeliveryInvoiceReport,
    route: "/delivery-invoice-report",
    role: [HO_ADMIN, CP_ADMIN, CP_OPERATOR],
  },
];
